import Vue from 'vue';
import {
  SAVE_ERP,
} from '@/store/mutation-types';

const erp = {
  state: {
    checkouts: [
      {
        id: 401,
        number: '4000000001',
        creationDate: '01/06/2019 18:00',
        startDate: '10/06/2019 18:00',
        closingDate: '30/06/2019 18:00',
        creatorUser: 'Francisco G.',
        status: 'Sent',
        items: [
          { id: '' },
        ],
      },
      {
        id: 402,
        number: '4000000002',
        creationDate: '08/08/2019 18:00',
        startDate: '08/08/2019 18:00',
        closingDate: '30/08/2019 18:00',
        creatorUser: 'Francisco G.',
        status: 'Sent',
        items: [
          { id: '' },
          { id: '' },
          { id: '' },
        ],
      },
    ],
  },
  mutations: {
    ADD_ITEM_ERP: (state, data) => {
      state.quotes.push(data);
      Vue.ls.set(SAVE_ERP, state);
    },
  },
  actions: {
    addExpressQuote({ commit }, quote) {
      commit('ADD_ITEM_ERP', quote);
    },
  },
  getters: {
    checkoutsInfo: state => state.checkouts,
  },
};

export default erp;



// WEBPACK FOOTER //
// ./src/store/modules/buyer/erp.js